import { defineMessages } from 'react-intl';

export default defineMessages({
   /* cancel: {
        id: 'quoteandbind.common.directives.CommonOfferingSelection.Cancel',
        defaultMessage: 'Cancel',
    },
    next: {
        id: 'quoteandbind.common.directives.CommonOfferingSelection.Next',
        defaultMessage: 'Next',
    },
    previous: {
        id: 'quoteandbind.common.directives.CommonOfferingSelection.Previous',
        defaultMessage: 'Previous',
    },*/
    cancel: {
        id: 'views.common.Cancel',
        defaultMessage: 'Cancel',
    },
    next: {
        id: 'views.common.Next',
        defaultMessage: 'Next',
    },
    previous: {
        id: 'views.common.Previous',
        defaultMessage: 'Previous',
    },
});
